import React from "react";
import { toast } from "sonner";
import { EyeOff, LogOut } from "lucide-react";

/**
 * When an admin has clicked "Preview as user" in the Mentors page, we store
 * their own token in `weave_token_admin_backup` and swap the active token
 * for the target user's. This banner floats at the very top of every page
 * so it's impossible to forget you're impersonating, and one click restores
 * your admin session.
 */
export default function ImpersonationBanner({ user }) {
  const backup = typeof window !== "undefined" && localStorage.getItem("weave_token_admin_backup");
  if (!backup || !user) return null;

  const stop = () => {
    localStorage.setItem("weave_token", backup);
    localStorage.removeItem("weave_token_admin_backup");
    toast.success("Signed back in as admin");
    window.location.assign("/dashboard");
  };

  return (
    <div
      className="sticky top-0 z-40 bg-[#F4B847] text-[#0A0A0A] border-b-2 border-[#0A0A0A] px-4 py-2 flex items-center justify-between gap-3 flex-wrap"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2 text-xs md:text-sm min-w-0">
        <EyeOff size={14} className="flex-shrink-0" />
        <span className="min-w-0">
          <strong className="uppercase tracking-wider mr-2">Preview mode</strong>
          Signed in as <strong>{user.name}</strong> ({user.role}) — this is what they see.
        </span>
      </div>
      <button
        onClick={stop}
        className="inline-flex items-center gap-1.5 bg-[#0A0A0A] text-[#F4B847] px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider hover:bg-[#1a1a1a] flex-shrink-0"
        data-testid="impersonation-return-btn"
      >
        <LogOut size={12} /> Return to admin
      </button>
    </div>
  );
}
